module.exports = __webpack_public_path__ + "static/media/shield-promo.30e01a72.svg";